import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useTranslation } from "react-i18next";
import InputAdornment from '@mui/material/InputAdornment';
import { NumericFormat } from "react-number-format";

export default function BalanceSheetAssets({ data, dataChange, dataChange1 }) {

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
      borderSpacing: "10px"
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const [totalCurrentAssets1, setTotalCurrentAssets1] = useState(calculateTotalCurrentAssets1());
  const [totalCurrentAssets2, setTotalCurrentAssets2] = useState(calculateTotalCurrentAssets2());
  const [totalCurrentAssets3, setTotalCurrentAssets3] = useState(calculateTotalCurrentAssets3());
  const [totalCurrentAssets, setTotalCurrentAssets] = useState(calculateTotalCurrentAssets());
  const [totalAssets, setTotalAssets] = useState(calculateTotalAssets());
  const [totalAssets1, setTotalAssets1] = useState(calculateTotalAssets());
  const [totalAssets2, setTotalAssets2] = useState(calculateTotalAssets());
  const [totalAssets3, setTotalAssets3] = useState(calculateTotalAssets());

  function calculateTotalAssets() {
    const relevantFields = [
            "netPropertyAndEquipment",
            "otherAssets",
        ];

    const sum = relevantFields.reduce((acc, field) => {
      return acc + (parseFloat(data[0]?.[field]) || 0);
    }, 0);

    return sum + totalCurrentAssets; // Add totalCurrentAssets to the sum
  }
  function calculateTotalAssets1() {
    const relevantFields = [
            "netPropertyAndEquipment",
            "otherAssets",
        ];

    const sum = relevantFields.reduce((acc, field) => {
      return acc + (parseFloat(data[1]?.[field]) || 0);
    }, 0);

    return sum + totalCurrentAssets1; // Add totalCurrentAssets to the sum
  } function calculateTotalAssets2() {
    const relevantFields = [
            "netPropertyAndEquipment",
            "otherAssets",
        ];

    const sum = relevantFields.reduce((acc, field) => {
      return acc + (parseFloat(data[2]?.[field]) || 0);
    }, 0);

    return sum + totalCurrentAssets2; // Add totalCurrentAssets to the sum
  } function calculateTotalAssets3() {
    const relevantFields = [
            "netPropertyAndEquipment",
            "otherAssets",
        ];

    const sum = relevantFields.reduce((acc, field) => {
      return acc + (parseFloat(data[3]?.[field]) || 0);
    }, 0);

    return sum + totalCurrentAssets3; // Add totalCurrentAssets to the sum
  }
  function calculateTotalCurrentAssets() {
    const relevantFields = [
      "cashAndCashEquivalents",
      "investments",
      "receivablesCurrent",
      "receivableRetainage",
      "costsAndEstimatedEarningsInExcessOfBillingsOnUncompletedContracts",
      "refundableIncomeTaxes",
      "noteReceivable",
      "otherCurrentAssets"
    ];

    const sum = relevantFields.reduce((acc, field) => {
      return acc + (parseFloat(data[0]?.[field]) || 0);
    }, 0);

    return sum;
  }
  function calculateTotalCurrentAssets1() {
    const relevantFields = [
      "cashAndCashEquivalents",
      "investments",
      "receivablesCurrent",
      "receivableRetainage",
      "costsAndEstimatedEarningsInExcessOfBillingsOnUncompletedContracts",
      "refundableIncomeTaxes",
      "noteReceivable",
      "otherCurrentAssets"
    ];

    const sum = relevantFields.reduce((acc, field) => {
      return acc + (parseFloat(data[1]?.[field]) || 0);
    }, 0);

    return sum;
  } function calculateTotalCurrentAssets2() {
    const relevantFields = [
      "cashAndCashEquivalents",
      "investments",
      "receivablesCurrent",
      "receivableRetainage",
      "costsAndEstimatedEarningsInExcessOfBillingsOnUncompletedContracts",
      "refundableIncomeTaxes",
      "noteReceivable",
      "otherCurrentAssets"
    ];

    const sum = relevantFields.reduce((acc, field) => {
      return acc + (parseFloat(data[2]?.[field]) || 0);
    }, 0);

    return sum;
  } function calculateTotalCurrentAssets3() {
    const relevantFields = [
      "cashAndCashEquivalents",
      "investments",
      "receivablesCurrent",
      "receivableRetainage",
      "costsAndEstimatedEarningsInExcessOfBillingsOnUncompletedContracts",
      "refundableIncomeTaxes",
      "noteReceivable",
      "otherCurrentAssets"
    ];

    const sum = relevantFields.reduce((acc, field) => {
      return acc + (parseFloat(data[3]?.[field]) || 0);
    }, 0);

    return sum;
  }
  // Step 3: Update totalCurrentAssets whenever relevant fields change
  useEffect(() => {
    setTotalCurrentAssets(calculateTotalCurrentAssets());
    setTotalCurrentAssets1(calculateTotalCurrentAssets1());
    setTotalCurrentAssets2(calculateTotalCurrentAssets2());
    setTotalCurrentAssets3(calculateTotalCurrentAssets3());
    setTotalAssets(calculateTotalAssets());
    setTotalAssets1(calculateTotalAssets1());
    setTotalAssets2(calculateTotalAssets2());
    setTotalAssets3(calculateTotalAssets3());
  }, [data]);
  const datas = [totalCurrentAssets, totalCurrentAssets1, totalCurrentAssets2, totalCurrentAssets3]

  // console.log(datas);

  const realonlyField = ["totalCurrentAssets", "totalAssets"]


  const headColumns = [
    "cashAndCashEquivalents",
    "investments",
    "receivablesCurrent",
    "receivableRetainage",
    "costsAndEstimatedEarningsInExcessOfBillingsOnUncompletedContracts",
    "refundableIncomeTaxes",
    "noteReceivable",
    "otherCurrentAssets",
    "totalCurrentAssets",
    "netPropertyAndEquipment",
    "otherAssets",
    "totalAssets"
  ];

  const dollarColumns = [
        "cashAndCashEquivalents",
      
    ];

  const [currentlyFocused, setCurrentlyFocused] = useState(null);


  const { t } = useTranslation();
  return (
    <div>
      <TableContainer component={Paper}>

        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>&nbsp;</StyledTableCell>
              <StyledTableCell align="right" className='text-muted'>{('Current YTD')}</StyledTableCell>
              <StyledTableCell align="right" className='text-muted'>{('Previous Year')} </StyledTableCell>
              <StyledTableCell align="right" className='text-muted'>{('2 Years Previous')}</StyledTableCell>
              <StyledTableCell align="right" className='text-muted'>{('3 Years Previous')}&nbsp;</StyledTableCell>

            </TableRow>
          </TableHead>
          {headColumns.map((r, index) => (
            <React.Fragment key={index}>
              <TableRow sx={{ backgroundColor: realonlyField.indexOf(r) !== -1 ? " #F2F4F7" : "#fff" }} hidden={realonlyField.indexOf(r) !== -1}>
                <StyledTableCell >{t(r)}</StyledTableCell >
                <StyledTableCell align="right" className='text-muted'>
                  <NumericFormat customInput={TextField} thousandSeparator
                    autoFocus={`values1${index}` === currentlyFocused} onFocus={() => setCurrentlyFocused(`values1${index}`)}
                    disabled={realonlyField.indexOf(r) !== -1}
                    sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 } }}
                    size='small'
                    id="outlined-basic"
                    value={data?.[0]?.[r]}
                    variant="outlined"
                    //   onChange={(event) => {
                    //     
                    //     dataChange(0, r, event.target.value);
                    //   }}
                    onValueChange={(values) => {
                      
                      dataChange(0, r, values.floatValue);
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {dollarColumns.indexOf(r) !== -1 ? "$" : ""}
                        </InputAdornment>
                      ),
                    }}
                  />
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <NumericFormat
                    customInput={TextField}
                    decimalScale={0}
                    thousandSeparator=","
                    autoFocus={`values2${index}` === currentlyFocused}
                    onFocus={() => setCurrentlyFocused(`values2${index}`)}
                    disabled={realonlyField.indexOf(r) !== -1}
                    size="small"
                    id="outlined-basic"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    value={data?.[1]?.[r]}
                    variant="outlined"
                    // onChange={(event) => {
                    //   dataChange(1, r, event.target.value);
                    // }}
                    onValueChange={(values) => {
                      
                      dataChange(1, r, values.floatValue);
                    }}
                  />
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <NumericFormat
                    customInput={TextField}
                    decimalScale={0}
                    thousandSeparator=","
                    autoFocus={`values3${index}` === currentlyFocused}
                    onFocus={() => setCurrentlyFocused(`values3${index}`)}
                    disabled={realonlyField.indexOf(r) !== -1}
                    size="small"
                    id="outlined-basic"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    value={data?.[2]?.[r]}
                    variant="outlined"
                    // onChange={(event) => {
                    //   dataChange(2, r, event.target.value);
                    // }}
                    onValueChange={(values) => {
                      
                      dataChange(2, r, values.floatValue);
                    }}
                  />
                </StyledTableCell>
                <StyledTableCell align="right" className="text-muted">
                  <NumericFormat
                    customInput={TextField}
                    decimalScale={0}
                    thousandSeparator=","
                    autoFocus={`values4${index}` === currentlyFocused}
                    onFocus={() => setCurrentlyFocused(`values4${index}`)}
                    disabled={realonlyField.indexOf(r) !== -1}
                    size="small"
                    id="outlined-basic"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    value={data?.[3]?.[r]}
                    variant="outlined"
                    // onChange={(event) => {
                    //   dataChange(3, r, event.target.value);
                    // }}
                    onValueChange={(values) => {
                      
                      dataChange(3, r, values.floatValue);
                    }}
                  />
                </StyledTableCell>
              </TableRow>
              {/* Add a condition to render the totalCurrentAssets row */}
              {r === "totalCurrentAssets" && (
                <TableRow sx={{ backgroundColor: "#F2F4F7" }}>
                  <StyledTableCell>{t(r)}</StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalCurrentAssets()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalCurrentAssets1()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalCurrentAssets2()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalCurrentAssets3()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                    />
                  </StyledTableCell>
                </TableRow>
              )}
              {r === "totalAssets" && (
                <TableRow sx={{ backgroundColor: "#F2F4F7" }}>
                  <StyledTableCell>{t(r)}</StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalAssets()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalAssets1()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalAssets2()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell align="right" className="text-muted">
                    {" "}
                    <NumericFormat
                      customInput={TextField}
                      decimalScale={0}
                      thousandSeparator=","
                      size="small"
                      id="outlined-basic"
                      value={calculateTotalAssets3()} // Provide the calculated value here
                      variant="outlined"
                      disabled // Disable editing of the calculated value
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                    />
                  </StyledTableCell>
                </TableRow>
              )}
            </React.Fragment>
          ))}

        </Table>
      </TableContainer>
    </div>
  )
}